const ArrowUpSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M12.1701 4.82227C12.0715 4.72433 11.9376 4.66931 11.7981 4.66931C11.6585 4.66931 11.5247 4.72433 11.426 4.82227L7.16504 10.0612L4.56007 7.47523C4.46082 7.38006 4.32789 7.3274 4.1899 7.32859C4.05192 7.32978 3.91993 7.38473 3.82236 7.48159C3.72478 7.57845 3.66944 7.70948 3.66824 7.84646C3.66704 7.98344 3.72009 8.11541 3.81595 8.21394L6.79298 11.1693C6.89167 11.2672 7.0255 11.3223 7.16504 11.3223C7.30459 11.3223 7.43842 11.2672 7.5371 11.1693L12.1701 5.56098C12.2688 5.46301 12.3242 5.33015 12.3242 5.19162C12.3242 5.05309 12.2688 4.92024 12.1701 4.82227Z"
        fill="#D5D5D5"
      />
    </svg>
  );
};

export default ArrowUpSvg;
